import { Object3D } from "three";
import { GameResourcesPackage } from "../../../../../resources/GameResourcesPackage";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";

export class SmokeParticle extends Object3D {
    private particles: Object3D;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly particlesRenderer: BatchedRenderer
    ) {
        super();
        this.particles = clone(this.gameResources.assets_game_particles_tractor_smoke_thjson);
        QuarksUtil.setAutoDestroy(this.particles, true);
        QuarksUtil.addToBatchRenderer(this.particles, this.particlesRenderer);
        this.add(this.particles);
    }
}
